import { HelpcenterData } from '../helpcenter-data';
import { createContext } from 'react';

export const HelpcenterContext = createContext<HelpcenterData>({} as any);
